import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './home-header.css'

const HomeHeader = (props) => {
  return (
    <div className={`home-header-header78 ${props.rootClassName} `}>
      <div className="home-header-column thq-section-padding thq-section-max-width">
        <h1>
          {props.heading ?? (
            <Fragment>
              <h1 className="home-header-text6">Welcome to DPS Tek</h1>
            </Fragment>
          )}
        </h1>
        <h1>
          {props.heading2 ?? (
            <Fragment>
              <h1 className="home-header-text4">
                Your Partner in Digital Transformation
              </h1>
            </Fragment>
          )}
        </h1>
        <span>
          {props.text1 ?? (
            <Fragment>
              <span className="home-header-text5">
                At DPS Tek, we empower your business to reach new heights with
                our comprehensive range of services in Cloud Computing, Web
                Development, Digital Marketing, SEO, and more. Whether
                you&apos;re looking to optimize your cloud infrastructure,
                create a stunning website, or enhance your online presence, our
                team of experts is here to help you succeed.
              </span>
            </Fragment>
          )}
        </span>
        <div className="home-header-content"></div>
        <div className="home-header-actions">
          <Link to="/services" className="home-header-button thq-button-filled">
            <span className="home-header-text3 thq-body-small">
              {props.action1}
            </span>
          </Link>
        </div>
      </div>
      <div className="home-header-content1">
        <div className="home-header-row-container thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal home-header-strip">
            <img
              alt={props.image1Alt}
              src={props.image1Src}
              className="home-header-placeholder-image thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image2Alt}
              src={props.image2Src}
              className="home-header-placeholder-image01 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image3Alt}
              src={props.image3Src}
              className="home-header-placeholder-image02 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image4Alt}
              src={props.image4Src}
              className="home-header-placeholder-image03 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image5Alt}
              src={props.image5Src}
              className="home-header-placeholder-image04 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image6Alt}
              src={props.image6Src}
              className="home-header-placeholder-image05 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal">
            <img
              alt={props.image1Alt}
              src={props.image1Src}
              className="home-header-placeholder-image06 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image2Alt}
              src={props.image2Src}
              className="home-header-placeholder-image07 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image3Alt}
              src={props.image3Src}
              className="home-header-placeholder-image08 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image4Alt}
              src={props.image4Src}
              className="home-header-placeholder-image09 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image5Alt}
              src={props.image5Src}
              className="home-header-placeholder-image10 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              src="https://images.unsplash.com/photo-1534312527009-56c7016453e6?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDIxfHxhYnN0cmFjdHxlbnwwfHx8fDE3MTA4NzA5MzB8MA&amp;ixlib=rb-4.0.3&amp;w=1500"
              className="home-header-placeholder-image11 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
        <div className="home-header-row-container1 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal-reverse home-header-strip2">
            <img
              alt={props.image7Alt}
              src={props.image7Src}
              className="home-header-placeholder-image12 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image8Alt}
              src={props.image8Src}
              className="home-header-placeholder-image13 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image9Alt}
              src={props.image9Src}
              className="home-header-placeholder-image14 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image10Alt}
              src={props.image10Src}
              className="home-header-placeholder-image15 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image11Alt}
              src={props.image11Src}
              className="home-header-placeholder-image16 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image12Alt}
              src={props.image12Src}
              className="home-header-placeholder-image17 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={props.image7Alt}
              src={props.image7Src}
              className="home-header-placeholder-image18 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image8Alt}
              src={props.image8Src}
              className="home-header-placeholder-image19 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image9Alt}
              src={props.image9Src}
              className="home-header-placeholder-image20 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image10Alt}
              src={props.image10Src}
              className="home-header-placeholder-image21 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image11Alt}
              src={props.image11Src}
              className="home-header-placeholder-image22 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              src="https://images.unsplash.com/photo-1568214379698-8aeb8c6c6ac8?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDEyfHxncmFmaWN8ZW58MHx8fHwxNzE1Nzk0OTk5fDA&amp;ixlib=rb-4.0.3&amp;w=1500"
              className="home-header-placeholder-image23 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
      </div>
      <div>
        <div className="home-header-container1">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

HomeHeader.defaultProps = {
  image6Src:
    'https://images.unsplash.com/photo-1557200134-90327ee9fafa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2NXw&ixlib=rb-4.0.3&q=80&w=1500',
  image9Src:
    'https://images.unsplash.com/photo-1598209494655-b8e249540dfc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2NXw&ixlib=rb-4.0.3&q=80&w=1500',
  image4Src:
    'https://images.unsplash.com/photo-1491975474562-1f4e30bc9468?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2Nnw&ixlib=rb-4.0.3&q=80&w=1500',
  image5Alt: 'Hero Image',
  rootClassName: '',
  image6Alt: 'Hero Image',
  image1Alt: 'Digital Marketing Company Hero Image',
  image12Src:
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2NXw&ixlib=rb-4.0.3&q=80&w=1500',
  image10Alt: 'Hero Image',
  image11Src:
    'https://images.unsplash.com/photo-1545113972-bbccc3547465?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2M3w&ixlib=rb-4.0.3&q=80&w=1500',
  image5Src:
    'https://images.unsplash.com/photo-1521063512073-432ce10aed90?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2Nnw&ixlib=rb-4.0.3&q=80&w=1500',
  image1Src:
    'https://images.unsplash.com/photo-1497366858526-0766cadbe8fa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2N3w&ixlib=rb-4.0.3&q=80&w=1500',
  action1: 'Learn About Services',
  image9Alt: 'Hero Image',
  image12Alt: 'Hero Image',
  image8Alt: 'Hero Image',
  image3Alt: 'Hero Image',
  heading2: undefined,
  image4Alt: 'Hero Image',
  text1: undefined,
  image11Alt: 'Hero Image',
  image8Src:
    'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2NXw&ixlib=rb-4.0.3&q=80&w=1500',
  image10Src:
    'https://images.unsplash.com/photo-1521063512073-432ce10aed90?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2Nnw&ixlib=rb-4.0.3&q=80&w=1500',
  image3Src:
    'https://images.unsplash.com/photo-1499750310107-5fef28a66643?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2Mnw&ixlib=rb-4.0.3&q=80&w=1500',
  image2Src:
    'https://images.unsplash.com/photo-1565350897149-38dfafa81d83?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2M3w&ixlib=rb-4.0.3&q=80&w=1500',
  image2Alt: 'Hero Image',
  heading: undefined,
  image7Alt: 'Hero Image',
  image7Src:
    'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMTA1OTc2NHw&ixlib=rb-4.0.3&q=80&w=1500',
}

HomeHeader.propTypes = {
  image6Src: PropTypes.string,
  image9Src: PropTypes.string,
  image4Src: PropTypes.string,
  image5Alt: PropTypes.string,
  rootClassName: PropTypes.string,
  image6Alt: PropTypes.string,
  image1Alt: PropTypes.string,
  image12Src: PropTypes.string,
  image10Alt: PropTypes.string,
  image11Src: PropTypes.string,
  image5Src: PropTypes.string,
  image1Src: PropTypes.string,
  action1: PropTypes.string,
  image9Alt: PropTypes.string,
  image12Alt: PropTypes.string,
  image8Alt: PropTypes.string,
  image3Alt: PropTypes.string,
  heading2: PropTypes.element,
  image4Alt: PropTypes.string,
  text1: PropTypes.element,
  image11Alt: PropTypes.string,
  image8Src: PropTypes.string,
  image10Src: PropTypes.string,
  image3Src: PropTypes.string,
  image2Src: PropTypes.string,
  image2Alt: PropTypes.string,
  heading: PropTypes.element,
  image7Alt: PropTypes.string,
  image7Src: PropTypes.string,
}

export default HomeHeader
